"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SickLeaveVerifyDoctor_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var Location_1 = require("./Location");
var SickLeaveVerifyDoctorRequestBody_1 = require("./SickLeaveVerifyDoctorRequestBody");
var SickLeaveVerifyDoctor_Factory = /** @class */ (function () {
    function SickLeaveVerifyDoctor_Factory() {
    }
    SickLeaveVerifyDoctor_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedBy: User_1.User_Factory.CreateIncoming(model.CreatedBy),
            CreatedById: model.CreatedById,
            DoctorId: model.DoctorId,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestBody: SickLeaveVerifyDoctorRequestBody_1.SickLeaveVerifyDoctorRequestBody_Factory.CreateIncoming(model.RequestBody),
            RequestJson: model.RequestJson,
            ResponseCode: model.ResponseCode,
            ResponseJson: model.ResponseJson,
            SehaOrganizationId: model.SehaOrganizationId,
        };
        return result;
    };
    SickLeaveVerifyDoctor_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CreatedBy: User_1.User_Factory.CreateOutgoing(model.CreatedBy),
            CreatedById: model.CreatedById,
            DoctorId: model.DoctorId,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestBody: SickLeaveVerifyDoctorRequestBody_1.SickLeaveVerifyDoctorRequestBody_Factory.CreateOutgoing(model.RequestBody),
            RequestJson: model.RequestJson,
            ResponseCode: model.ResponseCode,
            ResponseJson: model.ResponseJson,
            SehaOrganizationId: model.SehaOrganizationId,
        };
        return result;
    };
    return SickLeaveVerifyDoctor_Factory;
}());
exports.SickLeaveVerifyDoctor_Factory = SickLeaveVerifyDoctor_Factory;
